module.exports = __webpack_public_path__ + "img/snake.02869d08.jpg";